
/**
 * Scroll to bottom to read and understand more about this store.
 */
const storeKey = "perkxi";


const setStore = () => {

    sessionStorage.setItem(
        storeKey, JSON.stringify({
            activeElement: null,
            activeRule: null,
            props: {}
        })
    );
};

const setActiveElement = (activeElement) => {

    if(sessionStorage.getItem(storeKey) == undefined) setStore();

    let store = sessionStorage.getItem(storeKey);
    store = JSON.parse(store);

    store.activeElement = activeElement;
    sessionStorage.setItem(storeKey, JSON.stringify(store)); 
};

const setRule = (activeRule) => {
    
    if(sessionStorage.getItem(storeKey) == undefined) setStore();

    let store = JSON.parse(sessionStorage.getItem(storeKey));
    store.activeRule = activeRule;

    const composerId = document.querySelector(".perxi-sm") ? 'perxi-composer-mobile' : 'perxi-composer-desktop';
    const styleSheet = document.getElementById(composerId).sheet.cssRules;

    sessionStorage.setItem(storeKey, JSON.stringify(store));

    for (let i = 0; i < styleSheet.length; i++) {
        const rule = styleSheet[i];
        const selectorText = rule.selectorText;

        if (selectorText === (composerId === 'perxi-composer-mobile' ? `.perxi-sm .${activeRule}` : `.${activeRule}`)) {
            setProps(rule.cssText);
            break;
        }
    }
};

const getRule = (key = "activeRule") => {

    if(sessionStorage.getItem(storeKey) == undefined) setStore();

    let store = sessionStorage.getItem(storeKey);
    store = JSON.parse(store);
    return store[key];

};

const addgetRule = (key = "activeRule") => {

    if(sessionStorage.getItem(storeKey) == undefined) setStore();

    let store = sessionStorage.getItem(storeKey);
    store = JSON.parse(store);
    return store;

};


/**
 * 
 * @param { string } cssString 
 * .some-element-wcticet { z-index: auto; padding-top: 3px; padding-right: 3px; padding-bottom: 3px; }
 * 
 */

const setProps = ( cssString ) => {

    let cssRules = cssString.split('}')[0].split('{'),
    rules = cssRules[1].trim(),
    rulesSplit = rules.split(';'),
    rulesObj = {};
    
    for (let i = 0; i < rulesSplit.length - 1; i++) {
    
        let keyValSplit = rulesSplit[i].split(':');
        rulesObj[ keyValSplit[0].trim() ] = keyValSplit[1].trim();
    
    }

    let store = sessionStorage.getItem(storeKey);
    store = JSON.parse(store);
    store.props = rulesObj;
    sessionStorage.setItem(storeKey, JSON.stringify(store)); 
   
};


export const storePerkXi = {
    setRule,
    getRule,
    addgetRule,
    setProps,
    setActiveElement
};
